import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import s11 from './Component/s11.png';
import s12 from './Component/s12.png';

function CustomAreaRugs() {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />

      <section className="relative overflow-hidden">
        <div
          className="relative flex min-h-[280px] items-end bg-cover bg-center sm:min-h-[360px] md:min-h-[420px]"
          style={{ backgroundImage: `url(${s11})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" />
          <div className="relative mx-auto w-full max-w-6xl px-4 pb-10 pt-24 sm:px-6 sm:pb-14 lg:px-8">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/70 sm:text-xs">
              Specialty service
            </p>
            <h1 className="mt-2 text-2xl font-semibold text-white sm:text-3xl md:text-4xl lg:text-5xl">
              Custom area rugs
            </h1>
            <p className="mt-2 max-w-xl text-sm text-white/85 sm:text-base md:text-lg">
              Wide variety of styles for homes and commercial spaces
            </p>
            <a
              href="/free-estimate"
              className="mt-5 inline-flex items-center justify-center rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:text-base"
            >
              Request an estimate
            </a>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16">
        <div className="mx-auto grid max-w-6xl gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div className="overflow-hidden rounded-[1.75rem] bg-white ring-1 ring-slate-200/80 [&_section]:bg-transparent [&_section]:py-6">
            <Request />
          </div>
          <div className="space-y-6 rounded-[1.75rem] bg-white p-6 shadow-sm ring-1 ring-slate-200/80 sm:p-8">
            <div>
              <h2 className="text-xl font-semibold sm:text-2xl">
                Why custom area rugs should be part of your decor
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                Custom area rugs are common additions to floors such as hardwood, laminate, tile, or
                luxury vinyl. They can even be placed over broadloom carpeting. These rugs pull a
                room&apos;s decor together by adding texture and color. Scatter rugs also provide a
                lot of functions, such as noise insulation. They may be small, but they have a
                large impact.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold sm:text-xl">
                Custom size rugs: Getting just what you want
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                Today&apos;s rooms aren&apos;t perfect squares; they&apos;re often oddly shaped with
                door sills, baseboards, bay windows, closets, and moldings. Stock rugs are only
                available in standard colors, sizes, and shapes. When you get custom area rugs, you
                get precisely what you want, when you want it.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                Come into our custom rugs department, where we will make your dream a reality.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h2 className="text-xl font-semibold sm:text-2xl md:text-3xl">Separate and define</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
            With today&apos;s layouts, it&apos;s not unusual to find one big room that includes both
            the living and dining areas. You can create a cozy seating area with a separate dining
            space with coordinating but different rugs in each area.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
            It&apos;s also not unusual to need an extra room, whether for a home library, office,
            etc.; that&apos;s easily done by sectioning off a corner and defining it with an area
            rug.
          </p>
          <h2 className="mt-10 text-xl font-semibold sm:text-2xl md:text-3xl">
            Preserving money and sentiment
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
            There&apos;s often a lot of leftover material with a new carpet installation; don&apos;t
            throw it out! Instead, use the excess carpet to make custom size rugs. Sometimes you
            also have a family heirloom that has too much sentimental value to part with — cut
            around that damage and create a rug.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <div className="overflow-hidden rounded-[1.75rem]">
            <img src={s12} alt="Custom area rug placement" className="w-full object-cover" />
          </div>
          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold sm:text-2xl">How to place custom area rugs</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                Area rugs must be large enough to fit under major furniture, such as sofas, while
                still having 12 to 18 inches of bare floor visible. Custom area rugs in dining rooms
                should be large enough to fit under the table and the chairs. You can place two
                matching runners on each side of the bed in the bedroom.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold sm:text-xl">
                Visit us for custom area rugs today
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">
                Bring your ideas to us, and we&apos;ll do the rest. The PacifiContract showroom is
                in San Rafael, CA and we work on residential and commercial projects in Marin
                County, San Francisco, East Bay, Sonoma County, and San Jose. Stop by today for
                your custom area rugs.
              </p>
              <a
                href="/free-estimate"
                className="mt-5 inline-flex items-center justify-center rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:text-base"
              >
                Request an estimate
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default CustomAreaRugs;
